// Schema for Caterers vendor-type-specific fields.

import {
  CATERER_SPEC, SERVICE_STYLES, FOOD_CONCEPTS, DIETARY_OPTIONS, CUISINE_TYPES,
  FOOD_SERVICE_OPTIONS, BAR_STYLES, BAR_SERVICE_OPTIONS,
} from '../constants/vendorOptions';
import { rentalItemsGroupFields } from './fragments/rentalItemsGroup';

export const caterersSchema = {
  vendorType: 'Caterers',
  fields: [
    { key: 'catererSpec', type: 'chips', label: 'Specializes In *', displayLabel: 'Specializes In', options: CATERER_SPEC },
    { key: 'foodLicensed', type: 'checkbox', label: 'Licensed by state health department' },
    {
      type: 'row',
      fields: [
        { key: 'catererStartingPrice', type: 'price', label: 'Event Starting Price', optional: true },
        { key: 'catererAvgPrice', type: 'price', label: 'Event Average Price', optional: true },
      ],
    },
    {
      key: 'foodServicesGroup',
      type: 'group',
      style: 'shaded',
      title: 'Food Services',
      showIf: { field: 'catererSpec', includes: 'Food Services' },
      fields: [
        {
          type: 'row',
          fields: [
            { key: 'foodStartingPrice', type: 'price', label: 'Starting Price/Person', displayLabel: 'Food Starting Price/Person', maxDigits: 4, displaySuffix: '/person', optional: true },
            { key: 'foodAvgPrice', type: 'price', label: 'Average Price/Person', displayLabel: 'Food Average Price/Person', maxDigits: 4, displaySuffix: '/person', optional: true },
          ],
        },
        { key: 'serviceStyles', type: 'chips', label: 'Service Style', options: SERVICE_STYLES, optional: true },
        { key: 'foodConcepts', type: 'chips', label: 'Food Concepts', options: FOOD_CONCEPTS, optional: true },
        { key: 'dietaryOptions', type: 'chips', label: 'Dietary Options', options: DIETARY_OPTIONS, optional: true },
        { key: 'cuisineTypes', type: 'chips', label: 'Cuisine Types', options: CUISINE_TYPES, optional: true },
        { key: 'foodServiceOptions', type: 'chips', label: 'Food Service Options', options: FOOD_SERVICE_OPTIONS, optional: true },
      ],
    },
    {
      key: 'barServicesGroup',
      type: 'group',
      style: 'shaded',
      title: 'Bar Services',
      showIf: { field: 'catererSpec', includes: 'Bar Services' },
      fields: [
        {
          type: 'row',
          fields: [
            { key: 'barStartingPrice', type: 'price', label: 'Starting Price/Person', displayLabel: 'Bar Starting Price/Person', maxDigits: 4, displaySuffix: '/person', optional: true },
            { key: 'barAvgPrice', type: 'price', label: 'Average Price/Person', displayLabel: 'Bar Average Price/Person', maxDigits: 4, displaySuffix: '/person', optional: true },
          ],
        },
        { key: 'barStyles', type: 'chips', label: 'Bar Styles', options: BAR_STYLES, optional: true },
        { key: 'barServiceOptions', type: 'chips', label: 'Bar Service Options', options: BAR_SERVICE_OPTIONS, optional: true },
      ],
    },
    { key: 'catererOffersOtherItems', type: 'checkbox', label: 'We offer rental items', displayLabel: 'Rental Items' },
    ...rentalItemsGroupFields('catererOffersOtherItems'),
  ],
  requiredChips: [
    { key: 'catererSpec', label: 'specialization' },
  ],
  priceValidations: [
    { startingKey: 'catererStartingPrice', avgKey: 'catererAvgPrice', label: 'Caterer Event' },
    { startingKey: 'foodStartingPrice', avgKey: 'foodAvgPrice', label: 'Food Services' },
    { startingKey: 'barStartingPrice', avgKey: 'barAvgPrice', label: 'Bar Services' },
  ],
};